import { supabase } from '../utils/supabaseClient';

/**
 * Create a new workout
 */
export const createWorkout = async (workoutData) => {
  try {
    const { data, error } = await supabase
      .from('workouts')
      .insert([workoutData])
      .select()
      .single();

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error creating workout:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get all public workouts
 */
export const getPublicWorkouts = async () => {
  try {
    const { data, error } = await supabase
      .from('workouts')
      .select('*')
      .eq('is_public', true)
      .order('created_at', { ascending: false });

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching workouts:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get workouts by program ID
 */
export const getWorkoutsByProgram = async (programId) => {
  try {
    const { data, error } = await supabase
      .from('workouts')
      .select('*')
      .eq('program_id', programId)
      .eq('is_public', true)
      .order('week_number', { ascending: true })
      .order('day_number', { ascending: true });

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching workouts by program:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get a single workout by ID
 */
export const getWorkoutById = async (id) => {
  try {
    const { data, error } = await supabase
      .from('workouts')
      .select('*')
      .eq('id', id)
      .single();

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching workout:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Update an existing workout
 */
export const updateWorkout = async (id, workoutData) => {
  try {
    const { data, error } = await supabase
      .from('workouts')
      .update(workoutData)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;

    return { success: true, data };
  } catch (error) {
    console.error('Error updating workout:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Delete a workout
 */
export const deleteWorkout = async (id) => {
  try {
    const { error } = await supabase
      .from('workouts')
      .delete()
      .eq('id', id);

    if (error) throw error;

    return { success: true };
  } catch (error) {
    console.error('Error deleting workout:', error);
    return { success: false, error: error.message };
  }
};
